module.exports = __webpack_public_path__ + "static/media/icoCrunch.683f4077.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/icoCrunch.png
// module id = 1862
// module chunks = 146